<template>
<div class="collaborationPage">
	<div class="collaborationImageBox" ref="headerImageRef">
		<img class="collaborationImage" src="@/assets/collaborationIMG.png" />
		<div class="collaborationTextBox">
			<div class="collaborationTitle" style="margin-top: 3rem;">
				真实案例，见证健康价值<br />
                Real Cases, Witnessing Wellness Value
			</div>
			<div class="collaborationText" style="margin-top: 3rem;">
				从教育局到企业，从社区到校园，PULSE的健康实践<br />
                From education bureaus to enterprises, from communities to campuses—PULSE’s wellness practices
			</div>
		</div>
	</div>

    <div style="height: 4rem; width: 1;" />
    <div class="caseBox">
        <div class="caseItem">
            <img class="casePic" src="@/assets/collaboration0.png"/>
            <div style="flex: 1; height: 1px;" />
            <div class="caseText">
                <div class="caseTitle">
                    区域青少年心理健康体系建设
                </div>
                <div style="height: 2.5rem; width: 1px;" />
                <div class="caseText1">
                    [ 教育类 ]
                </div>
                <div style="height: 2.5rem; width: 1px;" />
                <div class="caseText2">
                    <img src="@/assets/collab_deco.png" class="caseText2Icon" />
                    合作对象：徐州沛县教育局（覆盖全县中小学）
                </div>
                <div style="height: 1.4rem; width: 1px;" />
                <div class="caseText3">
                    徐州沛县教育局青少年心理健康数字化平台
                </div>
                <div style="height: 1.3rem; width: 1px;" />
                <div class="caseText4">
                    核心服务：区域监测平台部署、学生心理普查、分级预警干预、教师赋能培训、家校社协同体系搭建
                </div>
                <div style="height: 1.6rem; width: 1px;" />
                <div class="caseTextTags">
                    <div class="caseTextTagItem">
                        # 教育场景
                    </div>
                    <div style="height: 1px; width: 0.9rem;" />
                    <div class="caseTextTagItem">
                        # 区域部署
                    </div>
                    <div style="height: 1px; width: 0.9rem;" />
                    <div class="caseTextTagItem">
                        # 政策落地
                    </div>
                </div>
                <div style="height: 1.3rem; width: 1px;" />
                <div class="caseText5">
                    30 万 + 学生全覆盖、测评覆盖率 98%+
                </div>
            </div>
        </div>
        <div class="caseItem">
            <img class="casePic" src="@/assets/collaboration1.png"/>
            <div style="flex: 1; height: 1px;" />
            <div class="caseText">
                <div class="caseTitle">
                    企业 EAP 员工关爱项目
                </div>
                <div style="height: 2.5rem; width: 1px;" />
                <div class="caseText1">
                    [ 企业类 ]
                </div>
                <div style="height: 2.5rem; width: 1px;" />
                <div class="caseText2">
                    <img src="@/assets/collab_deco.png" class="caseText2Icon" />
                    合作对象：中石油川西分公司
                </div>
                <div style="height: 1.4rem; width: 1px;" />
                <div class="caseText3">
                    中石油川西职工心理健康关爱计划
                </div>
                <div style="height: 1.3rem; width: 1px;" />
                <div class="caseText4">
                    核心服务：员工心理体检、线上咨询服务、职场压力管理讲座、团体辅导活动、管理决策看板
                </div>
                <div style="height: 1.6rem; width: 1px;" />
                <div class="caseTextTags">
                    <div class="caseTextTagItem">
                        # 企业 EAP
                    </div>
                    <div style="height: 1px; width: 0.9rem;" />
                    <div class="caseTextTagItem">
                        # 职场压力
                    </div>
                    <div style="height: 1px; width: 0.9rem;" />
                    <div class="caseTextTagItem">
                        # 团队赋能
                    </div>
                </div>
            </div>
        </div>
        <div class="caseItem">
            <img class="casePic" src="@/assets/collaboration2.png"/>
            <div style="flex: 1; height: 1px;" />
            <div class="caseText">
                <div class="caseTitle">
                    社区老年认知健康筛查
                </div>
                <div style="height: 2.5rem; width: 1px;" />
                <div class="caseText1">
                    [ 医疗类 ]
                </div>
                <div style="height: 2.5rem; width: 1px;" />
                <div class="caseText2">
                    <img src="@/assets/collab_deco.png" class="caseText2Icon" />
                    合作对象： 首都医科大学公共卫生学院+北京天坛医院
                </div>
                <div style="height: 1.4rem; width: 1px;" />
                <div class="caseText3">
                    北京新村街道阿尔兹海默症早筛与干预项目
                </div>
                <div style="height: 1.3rem; width: 1px;" />
                <div class="caseText4">
                    核心服务：健康脑小程序部署、社区筛查组织、个性化训练推送、就医衔接服务
                </div>
                <div style="height: 1.6rem; width: 1px;" />
                <div class="caseTextTags">
                    <div class="caseTextTagItem">
                        # 社区健康
                    </div>
                    <div style="height: 1px; width: 0.9rem;" />
                    <div class="caseTextTagItem">
                        # 认知筛查
                    </div>
                    <div style="height: 1px; width: 0.9rem;" />
                    <div class="caseTextTagItem">
                        # 医疗联动
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>
</template>

<script>
export default {
	data() {
		return {
		}
	},
	methods: {

		emitHeroHeight() {
			const height = this.$refs.headerImageRef ? this.$refs.headerImageRef.offsetHeight : 20;
			this.$emit("headerImageRefHeight", height);
		}
	},
	created() {
	},
	mounted() {
		this.emitHeroHeight();
		window.addEventListener("resize", this.emitHeroHeight);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.emitHeroHeight);
	},
	watch: {
	},
}
</script>

<style lang="scss" scoped>
.collaborationPage {
    display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	.collaborationImageBox {
		width: 100%;
		height: 51.4rem;
		position: relative;
		background-color: #212121;

		.collaborationImage {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0px;
			left: 0px;
			object-fit: cover;
		}

		.collaborationTextBox {
			position: absolute;
			width: 1200px;
			left: calc((100% - 1200px) / 2);
			top: 20%;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: center;

			.collaborationTitle {
				font-size: 5.3rem;
				text-align: left;
				color: #FFFFFF;
			}
			.collaborationText {
				font-size: 1.5rem;
				line-height: 2.5rem;
				text-align: left;
				color: #FFFFFF;
			}
		}
	}

    .caseBox {
        width: 100rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        .caseItem {
            margin-top: 6.7rem;
            margin-bottom: 7.2rem;
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
        }
        .casePic {
            box-sizing: border-box;
            width: 37.75rem;
            height: auto;
        }
        .caseText {
            box-sizing: border-box;
            width: 50.4rem;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;

            .caseTitle {
                width: 100%;
                text-align: left;
                font-size: 3.5rem;
                line-height: 4.8rem;
                color: #333333;
                font-weight: 600;
            }
            .caseText1 {
                width: 100%;
                text-align: left;
                font-size: 2.7rem;
                line-height: 4rem;
                color: #333333;
            }
            .caseText2 {
                width: 100%;
                text-align: left;
                font-size: 1.5rem;
                line-height: 2.4rem;
                color: #333333;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;

                .caseText2Icon {
                    width: 2.3rem;
                    height: 2.3rem;
                    margin-right: 1rem;
                }
            }
            .caseText3 {
                width: 100%;
                text-align: left;
                font-size: 2rem;
                line-height: 3.2rem;
                color: #333333;
            }
            .caseText4 {
                width: 100%;
                text-align: left;
                font-size: 1.5rem;
                line-height: 2.4rem;
                color: #333333;
            }
            .caseTextTags {
                width: 100%;
                text-align: left;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;

                .caseTextTagItem {
                    padding: 0.3rem 1rem;
                    font-size: 1.3rem;
                    line-height: 2rem;
                    color: #78DFA2;
                    border: solid 0.1rem #78DFA2;
                    border-radius: 0.3rem;
                }
            }
            .caseText5 {
                width: 100%;
                text-align: left;
                font-size: 1.7rem;
                line-height: 2.7rem;
                color: #333333;
            }
        }
    }
}
</style>